/*
This file is located in the main branch
Last time the file was updated (UTC): [02.07.2024 18:53:06]
Permissions to update outside the main branch: [false]
*/

import { ValidatedInput } from '@finbeat/react-toolkit';
import { UserFilter as UserFilterModel } from 'models/api/users';
import { useTranslation } from 'react-i18next';
import { Col, Row } from 'reactstrap';

const UserFilter = () => {
    const { t } = useTranslation();

    return (
        <>
            <Row>
                <Col>
                    <ValidatedInput<UserFilterModel>
                        id="ds-id"
                        name="id"
                        label={t('BackOfficeId')}
                    />
                </Col>
            </Row>
            <Row>
                <Col>
                    <ValidatedInput<UserFilterModel>
                        id="ds-userName"
                        name="userName"
                        label={t('BackOfficeUsername')}
                    />
                </Col>
            </Row>
            <Row>
                <Col>
                    <ValidatedInput<UserFilterModel>
                        id="ds-fullname"
                        name="fullname"
                        label={t('BackOfficeFio')}
                    />
                </Col>
            </Row>
            <Row>
                <Col>
                    <ValidatedInput<UserFilterModel>
                        id="ds-show-inactive"
                        name="showInactive"
                        type="checkbox"
                        label={t('BackOfficeShowInactive')}
                    />
                </Col>
            </Row>
            <Row>
                <Col>
                    <ValidatedInput<UserFilterModel>
                        id="ds-show-technical-user"
                        name="showTechnicalUser"
                        type="checkbox"
                        label={t('BackOfficeShowTechnicalUser')}
                    />
                </Col>
            </Row>
        </>
    );
};

export default UserFilter;
